import { endLoading, startLoading } from 'ducks/loader';
import FileSaver from 'file-saver';
import moment from 'moment';
import ReactGA from 'react-ga';
import { retryRequest } from 'utils/common';
import { DeviceUtil } from 'utils/device.util';
import {
  downloadEaScreenshot,
  downloadSnapshot,
  getSnapshotUrlsBySL,
} from '../services/clients/backupBank';
import { setError } from './error';

const OUT_OF_CREDIT_DOWNLOAD =
  ' cannot be downloaded because you are out of credit. ' +
  'Please, upgrade your plan to get more credits';
// Action types
const SET_SNAPSHOT_URLS = 'core/api/v1/erl/backupbank/SET_SNAPSHOT_URLS';
const SET_PER_DIEM_VALUE = 'core/api/v1/erl/backupbank/SET_PER_DIEM_VALUE';
const SET_TIMERANGE_RESULTS = 'core/api/v1/erl/backupbank/SET_TIMERANGE_RESULTS';

// Reducer
const initialState = {
  snapshotUrls: [],
  timeRangeResults: null,
  perDiemFormValue: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SNAPSHOT_URLS:
      return {
        ...state,
        snapshotUrls: action.payload,
      };
    case SET_PER_DIEM_VALUE:
      return {
        ...state,
        perDiemFormValue: action.payload,
      };
    case SET_TIMERANGE_RESULTS:
      return {
        ...state,
        timeRangeResults: action.payload,
      };
    default:
      return state;
  }
};
// Action creators
export const downloadSnapshotPDF = (key, name) => async (dispatch, getState) => {
  const {
    user: { first_name, last_name },
  } = getState();
  ReactGA.event({
    category: 'Backup Bank',
    action: 'download',
    label: `${first_name} ${last_name} ${key}`,
  });
  dispatch(startLoading('downloadBackup'));
  try {
    const data = await downloadSnapshot({ key });
    await FileSaver(data, name || 'BlueCargo Screenshot bank');
  } catch (e) {
    if (e.response.status === 402) dispatch(setError('Screenshot' + OUT_OF_CREDIT_DOWNLOAD, e));
  } finally {
    dispatch(endLoading('downloadBackup'));
  }
};

export const getScreenshots = (slKey, region, cb) => async (dispatch) => {
  try {
    const dateTimeObj = moment().tz(region.timeZone);
    const date = dateTimeObj.format('YYYY-MM-DD');
    const time = dateTimeObj.format('HH:mm');
    const data = await getSnapshotUrlsBySL(slKey, date, time, undefined, undefined, region.code);
    cb(data);
  } catch (error) {
    console.error(error);
    dispatch(setError('Get Screenshots error', error));
  }
};

export const downloadEaScreenshotPDF =
  (requestBody, fileNameData, region, cb) => async (dispatch, getState) => {
    try {
      const { download } = requestBody || {};

      const res = await retryRequest(3, downloadEaScreenshot, requestBody);
      if (download) {
        const { data } = res || {};
        const { shippingLineKey, containerTypeName, containerNumber } = fileNameData;
        const containerTypeNameWithoutSpace = containerTypeName.replace(/\s/g, '');
        const time = moment().tz(region.timeZone).format('YYYY-MM-DD hh:mmA z');
        const containerNumString = `${containerNumber ? ` ${containerNumber}` : ''}`;
        const title = 'BlueCargo Per Diem Report';
        const fileName = `${time} -${containerNumString} ${shippingLineKey} ${containerTypeNameWithoutSpace} - ${title}`;
        const isIE = DeviceUtil.isIE();
        if (isIE) {
          const fileNameIE = `${fileName}.pdf`;
          const textFileAsBlob = new Blob([data], { type: 'application/pdf' });
          window.navigator.msSaveBlob(textFileAsBlob, fileNameIE);
        } else {
          await FileSaver(data, fileName);
        }
      }
      cb();
    } catch (error) {
      cb(error);
      console.error(error);
      dispatch(setError('Downloading error', error));
    }
  };
